import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
// 设置文件
import setting from '@/setting.js';
export default (function (context) {
  return {
    namespaced: true,
    state: {
      // 主题
      list: setting.time.list,
      // 现在激活的主题 这应该是一个名字 不是对象
      activeName: 8
    },
    getters: {
      /**
       * @description 返回当前的主题信息 不是一个名字 而是当前激活主题的所有数据
       * @param {Object} state state
       */
      activeSetting: function activeSetting(state) {
        return state.list.find(function (theme) {
          return theme.name === state.activeName;
        });
      }
    },
    actions: {
      /**
       * @description 激活一个主题
       * @param {String} themeValue 需要激活的主题名称
       */
      set: function set(_ref, themeName) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var state, commit, dispatch;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
                  // 检查这个主题在主题列表里是否存在
                  state.activeName = state.list.find(function (e) {
                    return e.name === themeName;
                  }) ? themeName : state.list[0].name; // utils.cookies.set('TimeZoneNN', state.activeName)
                  // db.dbSet()

                  _context.next = 4;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'api.time',
                    value: state.activeName,
                    user: false
                  }, {
                    root: true
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      load: function load(_ref2) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var state, commit, dispatch, activeName;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch;
                  _context2.next = 3;
                  return dispatch('d2admin/db/get', {
                    dbName: 'sys',
                    path: 'api.time',
                    defaultValue: state.activeName,
                    user: false
                  }, {
                    root: true
                  });

                case 3:
                  activeName = _context2.sent;
                  console.log(activeName, "选中的时区");
                  state.activeName = activeName; // 将 vuex 中的主题应用到 dom

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    },
    mutations: {
      /**
       * @description 将 vuex 中的主题应用到 dom
       * @param {Object} state state
       */
    }
  };
});